import { Form, Select, Alert } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import { InputSearch } from '../../../input-search'
import { getMetaAdsAdAccounts, getMetaAdsPixels } from '../../../../services/meta-ads-integration'

const events = [
    { label: 'Compra', value: 'Purchase' },
    { label: 'Lead Enviado', value: 'LeadSubmitted' },
    { label: 'Iniciar Checkout', value: 'InitiateCheckout' },
    { label: 'Adicionar ao Carrinho', value: 'AddToCart' },
    { label: 'Visualizar Conteúdo', value: 'ViewContent' },
    { label: 'Pedido Criado', value: 'OrderCreated' },
    { label: 'Pedido Enviado', value: 'OrderShipped' },
    { label: 'Pedido Entregue', value: 'OrderDelivered' },
    { label: 'Pedido Cancelado', value: 'OrderCanceled' },
    { label: 'Pedido Devolvido', value: 'OrderReturned' },
    { label: 'Carrinho Abandonado', value: 'CartAbandoned' },
    { label: 'Lead Qualificado', value: 'QualifiedLead' },
    { label: 'Aplicação Enviada', value: 'ApplicationSubmitted' },
    { label: 'Agendamento Marcado', value: 'AppointmentScheduled' },
]

export default function SendEvent({ form, fieldName, integrationId }) {
    const [error, setError] = useState(null)

    const selectedAccountId = Form.useWatch(['actions', fieldName, 'action', 'data', 'accountId'], form)

    // Callback wrapper for account search
    const getAccountsCallback = useCallback(async () => {
        if (!integrationId) return { data: [] }
        try {
            const response = await getMetaAdsAdAccounts(integrationId)
            return response
        } catch (err) {
            setError('Erro ao carregar contas de anúncio.')
            return { data: [] }
        }
    }, [integrationId])

    // Callback wrapper for pixel search
    const getPixelsCallback = useCallback(async () => {
        if (!integrationId || !selectedAccountId) return { data: [] }
        try {
            const response = await getMetaAdsPixels(integrationId, selectedAccountId)
            return response
        } catch (err) {
            setError('Erro ao carregar pixels.')
            return { data: [] }
        }
    }, [integrationId, selectedAccountId])

    // Track previous accountId to only clear pixelId on actual change
    const prevAccountIdRef = React.useRef(selectedAccountId)

    // Clear pixel when account changes (but not on initial load)
    useEffect(() => {
        if (prevAccountIdRef.current !== undefined && prevAccountIdRef.current !== selectedAccountId) {
            form.setFieldValue(['actions', fieldName, 'action', 'data', 'pixelId'], undefined)
        }
        prevAccountIdRef.current = selectedAccountId
    }, [selectedAccountId, form, fieldName])

    if (error) {
        return <Alert message={error} type="error" showIcon />
    }

    return (
        <>
            <Form.Item name={[fieldName, 'action', 'integrationId']} initialValue={integrationId} noStyle />
            <Form.Item
                label="Conta de Anúncio"
                name={[fieldName, 'action', 'data', 'accountId']}
                rules={[{ required: true, message: 'Selecione uma conta de anúncio' }]}
            >
                <InputSearch
                    getCallback={getAccountsCallback}
                    valueKey="id"
                    searchField="name"
                    placeholder="Selecione a conta de anúncio"
                />
            </Form.Item>

            <Form.Item
                label="Pixel ID"
                name={[fieldName, 'action', 'data', 'pixelId']}
                rules={[{ required: true, message: 'Selecione um Pixel' }]}
            >
                <InputSearch
                    key={selectedAccountId}
                    getCallback={getPixelsCallback}
                    valueKey="id"
                    searchField="name"
                    placeholder="Selecione o Pixel"
                    disabled={!selectedAccountId}
                />
            </Form.Item>

            <Form.Item
                label="Evento"
                name={[fieldName, 'action', 'data', 'event']}
                rules={[{ required: true, message: 'Selecione um evento' }]}
            >
                <Select
                    options={events}
                    placeholder="Selecione o evento"
                    showSearch
                    filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                />
            </Form.Item>
        </>
    )
}
